// extracted by mini-css-extract-plugin
export default {"hotelTitle":"hotel_title_hotelTitle__4wTMx"};